<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 0 ? "NOVO" : "ATUALIZAR" }} USUÁRIO</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">

        <vs-input label="Nome" v-model="dataName" class="mt-5 w-full" name="user-name" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('user-name')">{{ errors.first('user-name') }}</span>

        <vs-input label="Usuário" v-model="dataUsername" class="mt-5 w-full" name="user-username"
                  v-validate="'required'"/>
        <span class="text-danger text-sm"
              v-show="errors.has('user-username')">{{ errors.first('user-username') }}</span>

        <vs-select  v-validate="'required'" v-model="dataRole" name="user-role" label="Perfil" class="select-large mt-5 w-full">
          <vs-select-item :key="index" :value="role.value" :text="role.text" v-for="(role,index) in roles" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('user-role')">{{ errors.first('user-role') }}</span>

      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Salvar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
  import VuePerfectScrollbar from "vue-perfect-scrollbar";

  export default {
    props: {
      isSidebarActive: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        default: () => {
        }
      }
    },
    watch: {
      isSidebarActive(val) {
        if (!val) return;
        if (Object.entries(this.data).length === 0) {
          this.initValues();
          this.$validator.reset();
        } else {
          let {
            id,
            name,
            username,
            role
          } = JSON.parse(JSON.stringify(this.data));

          this.dataId = id;
          this.dataName = name;
          this.dataUsername = username;
          this.dataRole = role;

          this.initValues();
        }
      }
    },
    data() {
      return {
        dataId: null,
        dataName: "",
        dataUsername: "",
        dataRole: "",

        settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.6
        },
        roles: [
          {text: 'Usuário', value: 'user'},
          {text: 'Gerenciador', value: 'manager'},
          {text: 'Administrador', value: 'admin'},
        ],
      };
    },
    computed: {
      isSidebarActiveLocal: {
        get() {
          return this.isSidebarActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeSidebar");
          }
        }
      },
      isFormValid() {
        return !this.errors.any();
      }
    },
    methods: {
      initValues() {
        if (this.data.id) return;
        this.dataId = null;
        this.dataName = "";
        this.dataUsername = "";
        this.dataRole = "";
      },
      submitData() {
        this.$validator.validateAll().then(result => {
          if (result) {
            const payload = {
              id: this.dataId,
              name: this.dataName,
              username: this.dataUsername,
              role: this.dataRole,
            };

            if (this.dataId !== null && this.dataId >= 0) {
              this.$store.dispatch("moduleUsers/updateUser", payload);
            } else {
              delete payload.id;
              payload.password = process.env.VUE_APP_DEFAULT_PASSWORD;
              this.$store.dispatch("moduleUsers/addUser", payload);
            }

            this.$emit("closeSidebar");
            this.initValues();
          }
        });
      }
    },
    components: {
      VuePerfectScrollbar,
    }
  };
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
  }
</style>
